import notification from 'antd/lib/notification';
import 'antd/lib/notification/style/index';
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

class Notification {
  success(title, text) {
    notification.success({
      message: title,
      description: text,
      duration: 3,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  error(title, text, duration = 5) {
    notification.error({
      message: title,
      description: text,
      duration,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      },
      key: text
    })
  };

  info(title, text) {
    notification.info({
      message: title,
      description: text,
      duration: 5,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  warning(title, text, duration = 5) {
    notification.warning({
      message: title,
      description: text,
      duration,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  loading(key, text) {
    notification.open({
      key,
      message: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LoadingOutlined style={{ color: '#1089FF', fontSize: 16, marginRight: 10 }} spin />
          <span>{text}</span>
        </div>
      ),
      duration: 0,
      placement: 'topRight',
      closeIcon: <></>,
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  close(key) {
    notification.close(key);
  }

  hide() {
    notification.destroy();
  }
}


export default new Notification();
